import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { useQuery } from '@tanstack/react-query';
import { legacyPermissionsControllerAtMeQueryOptions } from 'korint-sdk';
import { ArchiveIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '../../ui/alert';
import { BranchExplorer } from '../BranchExplorer/BranchExplorer';
import { Group } from '@folio/components/ui/flex';

export function ArchivedBranchBanner() {
  const { t } = useTranslation();
  const { workingBranch } = usePolicyOnDashboard();
  const { data: user } = useQuery(legacyPermissionsControllerAtMeQueryOptions());
  if (
    !(user?.brokerageFirmId || user?.isSuperUser) ||
    workingBranch?.branchStatus !== 'BRANCH_CLOSED' ||
    (workingBranch.branchType !== 'MTA' && workingBranch.branchType !== 'NEW_BUSINESS')
  )
    return null;

  return (
    <Alert variant="info" className="flex flex-wrap items-center justify-between gap-3">
      <Group align="start" gap={3} className="min-w-0 flex-1">
        <ArchiveIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <AlertDescription className="max-w-prose">
          {t(workingBranch.branchType === 'MTA' ? 'archive.mtaGuidance' : 'archive.quoteGuidance')}
        </AlertDescription>
      </Group>
      <BranchExplorer triggerLabel={t('archive.chooseOpenProject')} />
    </Alert>
  );
}
